import React from 'react';
import ResetPasswordForm from './ResetPasswordForm';

import style from './ResetPasswordPage.module.css';

const ResetPasswordPage = React.memo(({ match }) => {
  const { token } = match.params;

  return (
    <section className={style.forgotPassword}>
      <h2 className={style.h2}>Reset Password</h2>
      <div className={`container ${style.container}`}>
        <div className={style.wrapper}>
          <ResetPasswordForm token={token} />
        </div>
      </div>
    </section>
  );
});

export default ResetPasswordPage;
